// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"131a1c4d","725":"12ee8c7d","741":"1ef7003c","995":"fff341bd"}[chunkId] + ".chunk.js";
};